import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 53472 53472"
    {...props}
  >
    <defs>
      {/* <style>{".str0{stroke:#000;stroke-width:1896.18}.fil1{fill:none}"}</style> */}
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M39709 948H13763c-3514 0-6717 1442-9049 3770-2324 2328-3766 5531-3766 9045v25945c0 3517 1443 6723 3766 9050 2319 2324 5524 3766 9049 3766h25946c3525 0 6731-1442 9049-3766 2324-2327 3766-5533 3766-9050V13763c0-3514-1442-6717-3770-9049-2328-2324-5531-3766-9045-3766z"
        className="stroke1"
        style={{
          fill: "none",
          fillRule: "nonzero",
          strokeWidth: 1896.18,
        }}
      />
      <g id="_2283700254768">
        <path
          d="M31018 29890c9098 4475 5851 18229-4242 18281-9541 47-13864-13030-4296-18327 22-2278-214-20261 193-21546 1328-4189 7339-3865 8211 212 281 1311 37 18420 134 21380z"
          className="fill-none stroke1"
          style={{
            stroke: "#000",
            strokeWidth: 1516.94,
          }}
        />
        <path
          d="M27671 34672c2559 695 4502 2435 4310 5580-391 6384-9884 6484-10478 178-204-2162 914-4127 2469-5041l1685-769c29-15 83-43 122-68l10-11967 1750-14c334 999 128 10256 132 12101z"
          style={{
            fill: "#1c1b17",
            // stroke: "#000",
            strokeWidth: 577.956,
          }}
          className="fill"
        />
      </g>
      <path
        d="M34438 10267h7251M34438 16422h7251M34438 22574h7251"
        className="fill-none stroke1"
        style={{
          strokeWidth: 1896.18,
        }}
      />
    </g>
  </svg>
);
export default SvgComponent;
